<div class="main">
    <div class="section">
      <div class="head">
        <div class="label">
          {{'SHARE.share_title' | translate}}
          <i class="material-icons" (click)="closeModal();">clear</i>
        </div>
      </div>
      <div class="body">
        <div class="inputContainer">
          <div class="label">
            {{'SHARE.share_label' | translate}}
          </div>
          <input class="input"  type="text" [(ngModel)]="track" #trackingUrl>          
          <div>
            <img src="assets/copyround.svg" alt="" class="copy" (click)="copyUrl(trackingUrl);">
            <img src="assets/whatsappround.svg" alt="" (click)="whatsApp() ;">
          </div>
      </div>
      </div>
    </div>
  </div>
  